export const DEFAULT_MAX_BINS = 100;
